export default {
    title: 'Edit User: <strong>{email}</strong>',
    success: 'User <strong>{email}</strong> was successfully updated!',
    password: 'Registration email was sent to <strong>{email}</strong>!'
}
